import { useCallback } from "react";
import { useAbility } from "./ability-context";
import { type Action, type Resource } from "./rbac";

export function useCan() {
  const ability = useAbility();

  return useCallback(
    (action: Action, subject: Resource) => ability.can(action, subject),
    [ability],
  );
}
